module.exports = __webpack_public_path__ + "media/images/phone-28f4330341c249bc05b1528018795133a59af24ab2587c315cc7860fca1b5024.png";